import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';
import { useRenumerationModal } from '../context/RenumerationModalContext';

const AutomaticRenumerationMode: FC = () => {
  const { t } = useTranslate();

  const { data } = useRenumerationModal();

  return (
    <div className="automatic-view mt-3">
      <div className="automatic-view__callout">
        <div className="automatic-view__icon">
          <em className="icon ni ni-spark" />
        </div>
        <div className="automatic-view__body">
          <p className="automatic-view__title">
            {t('AutomaticRenumerationTitle')}
          </p>
          <p className="automatic-view__text">
            {t('AutomaticRenumerationDescription')}
          </p>
        </div>
      </div>

      <ol className="automatic-view__steps">
        <li className="automatic-view__step">
          <span className="automatic-view__step-n">1</span>
          <span>{t('AutomaticRenumerationStep1')}</span>
        </li>
        <li className="automatic-view__step">
          <span className="automatic-view__step-n">2</span>
          <span>{t('AutomaticRenumerationStep2')}</span>
        </li>
        <li className="automatic-view__step">
          <span className="automatic-view__step-n">3</span>
          <span>{t('AutomaticRenumerationStep3')}</span>
        </li>
      </ol>

      <div className="automatic-view__metrics">
        <div className="automatic-view__metric">
          <span className="automatic-view__n">
            {formatNumber(data.totalClasses)}
          </span>
          <span className="automatic-view__l">{t('Classes')}</span>
        </div>
        <div className="automatic-view__metric">
          <span className="automatic-view__n">
            {formatNumber(data.totalPartners)}
          </span>
          <span className="automatic-view__l">{t('Shareholders')}</span>
        </div>
        <div className="automatic-view__metric">
          <span className="automatic-view__n">
            {formatNumber(data.totalShares)}
          </span>
          <span className="automatic-view__l">{t('Shares')}</span>
        </div>
      </div>
    </div>
  );
};

export default AutomaticRenumerationMode;
